var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00002 0.25C5.19404 0.25 1.98367 3.08406 1.5116 6.86064L0.52268 14.772C0.325018 16.3533 1.55801 17.75 3.15161 17.75H4.51258L4.56492 17.8678C5.3439 19.6205 7.08199 20.75 8.99998 20.75C10.918 20.75 12.6561 19.6205 13.435 17.8678L13.4874 17.75H14.8484C16.442 17.75 17.675 16.3533 17.4774 14.772L16.4884 6.86064C16.0164 3.08406 12.806 0.25 9.00002 0.25ZM13.0171 16.25C13.0059 16.2498 12.9948 16.2498 12.9837 16.25H5.01628C5.00516 16.2498 4.99402 16.2498 4.98287 16.25H3.15161C2.46026 16.25 1.92534 15.6441 2.0111 14.958L3.00002 7.04669C3.37826 4.02075 5.95053 1.75 9.00002 1.75C12.0495 1.75 14.6218 4.02075 15 7.04669L15.9889 14.958C16.0747 15.6441 15.5398 16.25 14.8484 16.25H13.0171ZM6.20519 17.75H11.7948C11.1806 18.6765 10.136 19.25 8.99998 19.25C7.86402 19.25 6.81938 18.6765 6.20519 17.75Z",
    fill: "#22282F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.1530921b341e516219bcf3c704623d01.svg";
export { ForwardRef as ReactComponent };